import { Route, Routes } from 'react-router-dom'
import * as React from 'react'
import SaleCheckout from '../../Pages/BioBank/SaleCheckout/SaleCheckout'
import SaleItemsCart from '../../Pages/BioBank/Cart/SaleItemsCart'
import OrdersList from '../../Pages/BioBank/OrdersList/OrdersList'
import OrderDetails from '../../Pages/BioBank/OrderDetails/OrderDetails'
import ItemPageSales from '../../Pages/BioBank/ItemPageSales'
import ItemPageStorage from '../../Pages/BioBank/ItemPageStorage'

function BioBankRouter() {
  return (
    <Routes>
      <Route
        index
        element={<ItemPageSales />}
      />
      <Route path="cart">
        <Route
          index
          element={<SaleItemsCart />}
        />
        <Route
          path="checkout"
          element={<SaleCheckout />}
        />
      </Route>
      <Route
        path="storage"
        element={<ItemPageStorage />}
      />
      <Route path="order">
        <Route
          index
          element={<OrdersList />}
        />
        <Route
          path=":order_id"
          element={<OrderDetails />}
        />
      </Route>
    </Routes>
  )
}

export default BioBankRouter
